
$( document ).ready(function() {
if($('.table-cell.image img').length > 0){
	$('.table-cell.image img').replaceWith("<div class=\"overlay\"><a href=\"#\">"+$(".table-cell.image img")[0].outerHTML+"</a></a><div style=\"clear: both;\"><span class=\"time\"></span></div><div style=\"clear: both;\"><a href=\"#\" class=\"playWrapper\" data-click=\"#show-video\"></a></div></div>");
	jQuery('[data-click]').click(function(){
	    jQuery(jQuery(this).data('click')).click();
	});
}

//$('#item-body #message.info').html('This is a private course forum and you must take the course to participate. <br /><i>Click the “Start Taking This Course” button above to get started.</i>');	
	
var $results = $('#message').find('*').filter(function() {
    return $(this).text() === 'This is a private group and you must request group membership in order to join.';
});
	
$results.html('This is a private course forum and you must take the course to participate.<br /><i>Click the “Start Taking This Course” button above to get started.</i>');	

function lastPath(x){
	var y = x.split('/').filter(function(x) {return x !=''})
	return y[y.length - 1];
}	


$('#completed-courses article').each(function(){

	var $discussLink = lastPath($(this).find('h2 a').attr('href'));

		$('<p class="sensei-results-links"><a href="/groups/'+$discussLink+'/forum" class="button">Forum</a></p>').insertAfter($(this).find('.meter-bottom'));
	$('.view-results').hide();
	
});	
	
 
if($('body').hasClass('completed-courses')){
$('.bp-menu.bp-courses-nav').removeClass('current_page_item current-menu-item');
$('.lcms-custom').addClass('current_page_item current-menu-item');
}
	
//Changing Course/s to Module/s
$('.course-lessons-widgets footer span p:first-of-type').text('Module by');	//
$('.course-lessons-widgets footer .bp-group-discussion a').text('Module Discussion');	
$('.course-lessons-widgets footer h4').text('About this Module');	
$('.course-header .table-cell.content span').text('Module');	
$('#nav-bar-filter #user-courses').text('Modules');
$('#subnav.item-list-tabs #active-courses').text('Active Modules');
$('#subnav.item-list-tabs #completed-courses').text('Completed Modules');	
$('#subnav.item-list-tabs #completed-courses-personal-li').after( $( '<li id="all-courses-li"><a id="all-courses" href="/modules/">Module Catalog</a></li>' ) );

$('#subnav.item-list-tabs #create-courses').text('Create a Module');
if($('#nav-experiences').length > 0){
	$('#nav-experiences').text('Module');
	$('#nav-experiences').attr('href',$('#nav-experiences').attr('href').replace("groups/","course/").replace("experiences/",""));
}
$('input[name=course_start]').val('Start taking this module');
$('.sensei-course-participants').each(function() {
    var text = $(this).text().replace(/\bcourses?\b/, 'module');
    $(this).text(text);
});
$('#activity-stream li .activity-header p:first-of-type').each(function() {
	if($(this).find(':contains("completed the course")').length){
		$(this).html(function () {
    return $(this).html().replace("course", "module"); 
		});
	}
});	
$('.sensei-message').each(function() {
		$(this).html(function () {
    return $(this).html().replace("course", "module"); 
		});
});	

$('.item-meta .desktop').each(function() {
		$(this).html(function () {
    return $(this).html().replace("Course", "Module"); 
		});
});	
	
$('.sensei-message a').not('.next-lesson', '.prev-lesson').each(function() {
		$(this).text(function () {
    return $(this).html().replace("course", "module"); 
		});
});		
	

	
$('button[name=course_complete]').each(function() {
	
		$(this).html(function () {
    return $(this).html().replace("Course", "Module"); 
		});

});		
	
$('#item-main-content, #buddypress, #content').fadeIn('fast');
	
//$('#message').each(function(){
//	if($(this).find('p:contains("You have no active courses. Take a Course!")').length) {
//		$(this).html('<p>You have no active modules. <a href="/courses-overview/">Take a Module!</a></p>');
//	}
//	if($(this).find('p:contains("You have not completed any courses yet.")').length) {
//		$(this).html('<p>You have not completed any modules yet.</p>');
//	}
//});	
	
	
$("a#show-video").on('click', function(){
  window.scrollTo(0, -100);
});
	

	
var logoSrc = $('#mastlogo #logo h2.site-title a img.boss-logo.large').attr('src');
var logo = '<img src='+logoSrc+' class="nav-lcms-logo" \>';	
$('#mobile-menu').prepend(logo);
	
});

